import { useCallback, useMemo } from 'react';
import * as Sentry from '@sentry/react';

import { OrderAheadProvider, useCreateOrderAheadSessionMutation } from '@ocx/graphql';
import { openUrlInWindowAsync } from '@ocx/utils-device';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { useShowGenericErrorSnackbar } from '@ocx-app/hooks/useShowGenericErrorSnackbar';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { useLoader } from '@ocx-app/lib/loader/LoaderProvider';

export const useOpenOloInNewWindow = () => {
  const { turnLoader } = useLoader();
  const [createOrderAheadSession, { loading, error }] = useCreateOrderAheadSessionMutation({
    variables: { provider: OrderAheadProvider.Olo },
  });
  const showGenericErrorSnackbar = useShowGenericErrorSnackbar();
  const open = useCallback(async () => {
    try {
      turnLoader(true);
      await openUrlInWindowAsync({
        urlGetter: async () => {
          const { data } = await createOrderAheadSession();
          if (!data?.result) return null;
          return data.result.iframeUrl;
        },
      });
    } catch (e) {
      Sentry.addBreadcrumb({ message: 'Error opening Olo order ahead' });
      showGenericErrorSnackbar();
    } finally {
      turnLoader(false);
    }
  }, [createOrderAheadSession, showGenericErrorSnackbar, turnLoader]);

  return useMemo(
    () => ({
      open,
      isLoading: loading,
      error,
    }),
    [error, loading, open],
  );
};
